import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import { Permission } from '../security/permission';

@Directive({
  standalone: false,
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private permission!: Permission;
  private hasView = false;
  private subscription!: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) { }

  @Input() set hasPermission(permission: Permission) {
    this.permission = permission;
    this.updateView();
  }

  @Input() hasNotPermission = false;

  ngOnInit(): void {
    this.subscription = this.permissionService.hasPermission$(this.permission)
      .subscribe(() => this.updateView());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateView(): void {
    let allowed = this.permissionService.hasPermission(this.permission);
    if (this.hasNotPermission) {
      allowed = !allowed;
    }
    if (allowed && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allowed && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}

